export const getDisplayEmail = (formValues) =>  formValues?.email ? formValues?.maskedEmail || formValues?.email : '';